import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { ProfileComponent } from "./profile.component";

@NgModule({
  declarations: [ProfileComponent, ChangePasswordComponent],
  imports: [CoreModule, SharedModule],
  exports: [ProfileComponent, ChangePasswordComponent],
})
export class ProfileModule {}
